import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { BasicModal, DefaultButton, ReduxSelectField } from 'common/components';
import { Field, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { changeUserDocumentType } from '../../_redux';
import staticStyles from './style';

function getTypeLabel(type) {
  const typeLabels = {
    passport: 'Passport',
    passport_with_face: 'Passport With Face',
    address_proof: 'Address Proof',
    identification_proof: 'Identification Proof',
    additional_document: 'Additional Document',
  };
  return typeLabels[type] || type;
}

const ChangeDocumentTypeModal = ({
  isOpen,
  onClose,
  userId,
  documentId,
  currentType,
  availableTypes,
  handleSubmit,
  submitting,
  changeUserDocumentType,
}) => {
  const submit = handleSubmit(values => {
    changeUserDocumentType(userId, documentId, values.newType);
    onClose();
    window.location.reload();
  });

  // 过滤掉当前类型
  const typeOptions = availableTypes
    .filter(type => type !== currentType)
    .map(type => ({
      value: type,
      label: getTypeLabel(type),
    }));

  return (
    <BasicModal
      isOpen={isOpen}
      onRequestClose={onClose}
      captionId="changeDocumentType"
      descriptionId="changeDocumentTypeDescription">
      <form onSubmit={submit} className="ChangeDocumentTypeModal">
        <div className="ChangeDocumentTypeModal__current">
          <FormattedMessage id="currentDocumentType" />
          {': '}
          <strong>{getTypeLabel(currentType)}</strong>
        </div>

        <div className="ChangeDocumentTypeModal__field">
          <Field
            component={ReduxSelectField}
            name="newType"
            textId="newDocumentType"
            options={typeOptions}
            validate={[required()]}
            disabled={submitting}
          />
        </div>

        <div className="ChangeDocumentTypeModal__buttons">
          <DefaultButton textId="justConfirm" butColor="success" type="submit" loading={submitting} />
          <DefaultButton textId="justCancel" butColor="default" onClick={onClose} disabled={submitting} />
        </div>
      </form>
      <style jsx>{staticStyles}</style>
    </BasicModal>
  );
};

ChangeDocumentTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  documentId: PropTypes.number.isRequired,
  currentType: PropTypes.string.isRequired,
  availableTypes: PropTypes.array.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  changeUserDocumentType: PropTypes.func.isRequired,
};

export default connect(null, {
  changeUserDocumentType: (userId, documentId, newType) => changeUserDocumentType.request(userId, documentId, newType),
})(
  reduxForm({
    form: 'change-document-type-form',
  })(ChangeDocumentTypeModal)
);
